// extracted by mini-css-extract-plugin
export default {"image":"About_image__eH02+"};